export default __webpack_public_path__ + "static/media/lgH3c.cdc201af.png";